//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import MediaTypeInfoShort from '@motionelements/core/src/components/product-card/sections/ProductCardMediaTypeInfoShortAudio.vue';

export default {
  name: 'product-card-audio-name',
  components: {
    TextTruncate: () => import('@motionelements/core/src/components/ui/TextTruncate.vue'),
    StemsToggle: () => import('@motionelements/core/src/components/product-card/sections/actions/ProductButtonStemsToggle.vue'),
    MediaTypeInfoShort,
  },
  props: {
    element: Object,
    showToggle: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showArtistName: {
      type: Boolean,
      default: true,
    },
    //
    reverse: Boolean,
  },
  data() {
    return {
      faMeSubscription,
    };
  },
  computed: {
    linkUrl() {
      return _.get(this.options, 'linkUrl') || this.element.html.url;
    },
    isSubscription() {
      return _.get(this.element, 'subscription');
    },
  },
};
